<script lang="ts" module>
  import type { Snippet } from 'svelte';

  import CTAButton from '@/ui/elements/buttons/CTAButton.svelte';
  import VersionBullet from '@/ui/elements/version/cmps/VersionBullet.svelte';
  import { tv } from '@/ui/tv';

  export interface HistoryItemProps<T> {
    item: T;
    children?: Snippet<[{ item: T }]>;
    selected?: boolean;
    onclick?: (item: T) => void;
    onrestore?: (item: T) => void;
    pos?: 'first' | 'last' | 'default' | 'single';
    divider?: 'top' | 'bottom' | 'none';
    index?: number;
  }

  const styles = tv({
    slots: {
      root: 'group fr-cs relative w-full gap-2',
      content: 'f1',
    },
    variants: {
      pos: {
        first: {
          content: 'pb-1 pt-2',
        },
        last: {
          content: 'py-1',
        },
        default: {
          content: 'py-1',
        },
        single: {},
      },
    },
  });
</script>

<script lang="ts" generics="T">
  let { item, divider, selected, children, pos, onclick, onrestore, index }: HistoryItemProps<T> =
    $props();
  let cn = $derived(styles({ pos }));
</script>

<div
  class={cn.root()}
  onclick={() => onclick?.(item)}
  onkeypress={(e) => (e.key === 'Enter' || e.key === 'Space') && onclick?.(item)}
  role="button"
  tabindex="0"
>
  <VersionBullet {selected} {pos} value={index} />
  <div class={cn.content()}>
    {#if divider === 'top'}
      <hr class="mb-2 border-t-c-divider" />
    {/if}
    <div class="fr-cc gap-2">
      <div
        class="fr-cs flex-1 gap-2 rounded-sm p-2 group-hover:bg-btn-tert-H group-focus:bg-btn-tert-H"
      >
        {@render children?.({ item })}
      </div>
      {#if selected && pos !== 'first' && onrestore}
        <div class="ml-auto">
          <CTAButton
            class="py-3"
            icon="RestoreVersion"
            label="Wiederherstellen"
            tooltip="Wiederherstellen"
            onclick={() => onrestore(item)}
          />
        </div>
      {:else}
        <div class="w-12"></div>
      {/if}
    </div>
    {#if divider === 'bottom'}
      <hr class="mt-2 border-t-c-divider" />
    {/if}
  </div>
</div>
